const motorPackageContents = [
  {
    name: "Motor",
    desc: "Kompletně smontovaný a připravený k instalaci.",
    img: "/images/tsdz8750w_1.png",
  },
  {
    name: "Kliky šlapek",
    desc: "Kvalitní hliníkové kliky pro optimální přenos síly. Ergonomický design zajišťuje pohodlné šlapání i při dlouhých jízdách.",
    img: "/images/kliky.png",
  },
  {
    name: "Montážní šrouby",
    desc: "Kompletní sada všech šroubů a upevňovacích prvků potřebných pro montáž motoru. Vše je součástí balení.",
    img: "/images/srouby.png",
  },
  {
    name: "Hlavní kabel",
    desc: "Hlavní kabel, do kterého se zapojují všechny komponenty elektrokola - displej, brzdové senzory a další příslušenství.",
    img: "/images/kabel.png",
  },
  {
    name: "Páčka plynu",
    desc: "Ergonomická páčka plynu pro plynulé ovládání výkonu motoru. Umožňuje přesnou regulaci rychlosti.",
    img: "/images/plyn.png",
  },
  {
    name: "Montážní klíč",
    desc: "Speciální klíč pro snadnou montáž a demontáž motoru. Usnadňuje instalaci a servisní zásahy.",
    img: "/images/klic.png",
  },
];

const getBatteryPackage = (batteryName, batteryDesc) => [
  {
    name: `Lithiová baterie ${batteryName}`,
    desc: batteryDesc,
    img: "/images/baterie.png",
  },
  {
    name: "Montážní rám na kolo",
    desc: "Pevný hliníkový držák pro bezpečné upevnění baterie na rám kola. Zajišťuje stabilní uchycení a snadnou montáž a demontáž baterie.",
    img: "/images/drzakbat.png",
  },
  {
    name: "Montážní šrouby",
    desc: "Kompletní sada šroubů a upevňovacích prvků pro montáž držáku baterie na rám kola. Vše potřebné je součástí balení.",
    img: "/images/sroubbat.png",
  },
  {
    name: "Nabíječka",
    desc: "Kvalitní nabíječka s ochranou proti přebití a přehřátí. Automaticky ukončí nabíjení při dosažení plné kapacity baterie.",
    img: "/images/nabijecka.png",
  },
  {
    name: "Konektor baterie",
    desc: "Standardní konektor pro bezpečné a spolehlivé připojení baterie k motoru. Odolný a umožňuje snadné odpojení baterie.",
    img: "/images/klice.png",
  },
  {
    name: "Klíče",
    desc: "Tyto klíče slouží pouze k uzamčení baterie k rámu kola, aby baterie držela pevně a nespadla na zem.",
    img: "/images/konektor.png",
  },
];

const standardBatteryAbout =
  "🔋 <strong>Životnost:</strong> Baterie vydrží až 1000 nabíjecích cyklů, což představuje přibližně 7-8 let provozu.<br/><br/>🛡️ <strong>Kvalitní BMS systém:</strong> Všechny naše baterie jsou vybaveny pokročilým Battery Management Systemem (BMS), který hlídá všechny důležité parametry baterie - napětí, teplotu, proud i stav každého článku. Díky tomu je baterie chráněna před přebíjením, podvybíjením i přehřátím a může poskytovat velmi vysoký výkon po dlouhou dobu bez rizika poškození.";
const standardBatteryTips =
  "<strong>Skladování:</strong> Pokud baterii nebudete používat déle než měsíc, skladujte ji nabitou na přibližně 70 % kapacity.<br/><br/><strong>Nabíjení:</strong> Pro co nejdelší životnost nabíjejte baterii co nejméně často - ideálně na maximum a ne po malých dávkách (např. po 20 %).";

export const detailedProducts = {
  mot_250: {
    id: "mot_250",
    name: "TSDZ2B 250W",
    price: 9799,
    type: "motor",
    images: ["/images/tsdz2b250w_1.png", "/images/tsdz2b250w_2.jpg", "/images/tsdz2b250w_3.png"],
    specsTable: [
      { label: "Výkon", value: "250W" },
      { label: "Max. výkon", value: "600W" },
      { label: "Napětí", value: "36V" },
      { label: "Max. rychlost", value: "45+ km/h" },
      { label: "Šířka středu", value: "68/73mm" },
      { label: "Max. kroutící moment", value: "80 Nm" },
      { label: "Regulátor", value: "36V/18A" },
      { label: "Efektivita", value: "Více než 78%" },
      { label: "Otáčky naprázdno", value: "110" },
      { label: "Hmotnost", value: "3,8 kg" },
      { label: "Převodový poměr", value: "1:35" },
      { label: "Rozměry", value: "195×165×120 mm" },
    ],
    about:
      "🏆 S motorem TSDZ2B 250W získáte absolutního šampiona v dojezdu! 🚴 Díky výjimečné efektivitě a nízké spotřebě je tento motor dokonalou volbou pro celodenní výlety. S 24Ah baterií se v ideálních podmínkách a s lehkou přípomocí můžete dostat až na neuvěřitelných 250 km na jedno nabití! 🔋 Motor se standardně dodává s omezovačem na 25 km/h pro legální provoz na silnicích. <strong>Po softwarovém odemknutí limitu přes displej však motor dokáže ve spojení se šlapáním uhánět rychlostí až 45 km/h! Pamatujte ale, že po takovém odemknutí ztrácí kolo homologaci a smí se používat výhradně mimo veřejné komunikace (off-road).</strong> ⚖️ Váží pouhých 3,8 kg, takže ho na kole sotva ucítíte. 🌧️ Voděodolné provedení a točivý moment 80 Nm vás podrží v každém kopci i za deště. ✨ Zlatá střední cesta pro rozumné peníze a bezkonkurenční dojezd!",
    legalInfo: {
      type: "green",
      title: "Legální pro provoz na komunikacích (Vyhláška č. 153/2023 Sb.)",
      text: "Tato přestavbová sada splňuje podmínky vyhlášky č. 153/2023 Sb. pro provoz na silnicích a cyklostezkách v ČR. Výkon motoru nepřesahuje limit 1 kW a asistence je z výroby elektronicky omezena do rychlosti 25 km/h. Při zachování tohoto továrního nastavení je kolo z pohledu zákona považováno za standardní jízdní kolo. Softwarové odblokování omezovače rychlosti a plného výkonu je povoleno výhradně pro jízdu mimo veřejné komunikace (off-road). Provozováním odblokovaného elektrokola na silnicích přebírá jezdec plnou právní a hmotnou odpovědnost.",
    },
    packageContents: motorPackageContents,
  },
  mot_750: {
    id: "mot_750",
    name: "TSDZ8 750W",
    price: 10999,
    type: "motor",
    images: [
      "/images/tsdz8750w_1.png",
      "/images/tsdz8750w_2.webp",
      "/images/tsdz8750w_3.webp",
      "/images/tsdz8750w_4.png",
    ],
    specsTable: [
      { label: "Výkon", value: "750W" },
      { label: "Max. výkon", value: "2 kW" },
      { label: "Napětí", value: "36V/48V" },
      { label: "Max. rychlost", value: "55+ km/h" },
      { label: "Šířka středu", value: "68/73mm" },
      { label: "Max. kroutící moment", value: "120 Nm" },
      { label: "Regulátor", value: "48V/22A" },
      { label: "Efektivita", value: "Více než 80%" },
      { label: "Otáčky naprázdno", value: "125" },
      { label: "Hmotnost", value: "4,8 kg" },
      { label: "Převodový poměr", value: "1:37" },
      { label: "Rozměry", value: "204×170×126 mm" },
      { label: "Dojezd (eco)", value: "až 200 km" },
    ],
    about:
      "💎 TSDZ8 750W je zlatý grál poměru cena/výkon! 🚴 Zapomeňte na kompromisy a trápění v kopcích. Tento středový motor je navržen pro jezdce, kteří chtějí opravdovou dynamiku a sílu. ⛰️ S masivním kroutícím momentem 120 Nm si se stoupáním hraje jako kočka s myší. V reálném provozu s ním bez problému udržíte cestovní rychlost kolem 45-50 km/h i v mírném stoupání! 🚀 S 48V 20Ah baterií zvládnete v eco režimu přes 150 km, a i když za to budete pořádně brát, bez problémů pokoříte hranici 100 km. ⚡ Využívá zpevněné vnitřnosti a vylepšený odvod tepla, takže snese mnohem drsnější zacházení než 250W verze. Přestože má brutální sílu, reakce na šlapání je díky torznímu snímači sametově plynulá a přirozená. 🌲 Perfektní parťák na traily, lesní cesty a adrenalinové off-road výlety, kde nechcete řešit, jestli ten kopec vůbec vyjedete. Vyjedete ho s úsměvem!",
    legalInfo: {
      type: "green",
      title: "Legální pro provoz na komunikacích (Vyhláška č. 153/2023 Sb.)",
      text: "Tato přestavbová sada splňuje podmínky vyhlášky č. 153/2023 Sb. pro provoz na silnicích a cyklostezkách v ČR. Výkon motoru nepřesahuje limit 1 kW a asistence je z výroby elektronicky omezena do rychlosti 25 km/h. Při zachování tohoto továrního nastavení je kolo z pohledu zákona považováno za standardní jízdní kolo. Softwarové odblokování omezovače rychlosti a plného výkonu je povoleno výhradně pro jízdu mimo veřejné komunikace (off-road). Provozováním odblokovaného elektrokola na silnicích přebírá jezdec plnou právní a hmotnou odpovědnost.",
    },
    packageContents: motorPackageContents,
  },
  mot_1000: {
    id: "mot_1000",
    name: "TSDZ16 1000W",
    price: 13199,
    type: "motor",
    images: ["/images/tsdz161000w_1.png", "/images/tsdz161000w_2.webp", "/images/tsdz161000w_3.png"],
    specsTable: [
      { label: "Výkon", value: "1000W" },
      { label: "Max. výkon", value: "2,5 kW" },
      { label: "Napětí", value: "48V/52V" },
      { label: "Max. rychlost", value: "65+ km/h" },
      { label: "Šířka středu", value: "68/73mm" },
      { label: "Max. kroutící moment", value: "160 Nm" },
      { label: "Regulátor", value: "52V/30A" },
      { label: "Efektivita", value: "Více než 82%" },
      { label: "Otáčky naprázdno", value: "140" },
      { label: "Hmotnost", value: "6 kg" },
      { label: "Převodový poměr", value: "1:40" },
      { label: "Rozměry", value: "220×180×135 mm" },
    ],
    about:
      "⚡ TSDZ16 1000W – Čistokrevné monstrum, které nezná hranice! 🚀 V peak režimu tento stroj dokáže poslat na zadní kolo přes 2000W výkonu! 💪 Toto už není běžné elektrokolo, tohle je elektrická motorka ukrytá v rámu bicyklu. S kroutícím momentem drtivých 160 Nm vás do prudkého kopce vystřelí tak, že zapomenete, že nějaká gravitace vůbec existuje. ⛰️ Na rovince není absolutně žádný problém dosáhnout reálné rychlosti přes 60 km/h, a to bez větší námahy jezdce. 🔥 Varování: Tento motor vyžaduje kolo v perfektním technickém stavu (silný řetěz e-bike ready, špičkové brzdy a pevnou kazetu), jinak z něj doslova udělá kůlničku na dříví. ⚠️ Pokud chcete jet na pohodu a šetřit baterii, můžete mu přes displej omezit výkon, ale jeho pravý revír je extrémní zátěž a maximální rychlost. 🏍️ Pokud hledáte čistý adrenalin, totální dominanci v terénu a kompromisy necháváte jiným, právě jste našli svůj vysněný motor!",
    legalInfo: {
      type: "green",
      title: "Legální pro provoz na komunikacích (Vyhláška č. 153/2023 Sb.)",
      text: "Tato přestavbová sada splňuje podmínky vyhlášky č. 153/2023 Sb. pro provoz na silnicích a cyklostezkách v ČR. Výkon motoru nepřesahuje limit 1 kW a asistence je z výroby elektronicky omezena do rychlosti 25 km/h. Při zachování tohoto továrního nastavení je kolo z pohledu zákona považováno za standardní jízdní kolo. Softwarové odblokování omezovače rychlosti a plného výkonu je povoleno výhradně pro jízdu mimo veřejné komunikace (off-road). Provozováním odblokovaného elektrokola na silnicích přebírá jezdec plnou právní a hmotnou odpovědnost.",
    },
    packageContents: motorPackageContents,
  },
  bat_36v13: {
    id: "bat_36v13",
    name: "36V 13Ah",
    price: 4749,
    type: "battery",
    images: ["/images/bat36V15-6+13Ah.png"],
    specsTable: [
      { label: "Napětí", value: "36V" },
      { label: "Kapacita", value: "13Ah" },
      { label: "Energie", value: "468Wh" },
      { label: "Články", value: "18650 2600mAh" },
      { label: "Rozložení", value: "10s5p" },
      { label: "BMS", value: "30A" },
      { label: "Špičkový výkon", value: "90A" },
      { label: "Hmotnost", value: "3,2 kg" },
      { label: "Dojezd (eco)", value: "až 80 km" },
    ],
    about: standardBatteryAbout,
    tips: standardBatteryTips,
    legalInfo: {
      type: "green",
      title: "Schváleno pro provoz na pozemních komunikacích",
      text: "Tato baterie s pracovním napětím do 48V podléhá evropské normě EN 15194 a je plně schválena pro provoz na pozemních komunikacích v kombinaci s odpovídajícím motorem. Za jakékoliv vlastní úpravy nese plnou zodpovědnost kupující.",
    },
    packageContents: getBatteryPackage(
      "36V 13Ah",
      "Výkonná lithiová baterie s kapacitou 468Wh, články 18650 2600mAh v rozložení 10s5p. Vybavena kvalitním BMS systémem 30A (peak 90A) pro maximální bezpečnost a výkon."
    ),
  },
  bat_36v15_6: {
    id: "bat_36v15_6",
    name: "36V 15.6Ah",
    price: 5149,
    type: "battery",
    images: ["/images/bat36V15-6+13Ah.png"],
    specsTable: [
      { label: "Napětí", value: "36V" },
      { label: "Kapacita", value: "15.6Ah" },
      { label: "Energie", value: "561.6Wh" },
      { label: "Články", value: "18650 2600mAh" },
      { label: "Rozložení", value: "10s6p" },
      { label: "BMS", value: "30A" },
      { label: "Špičkový výkon", value: "90A" },
      { label: "Hmotnost", value: "3,8 kg" },
      { label: "Dojezd (eco)", value: "až 90 km" },
    ],
    about: standardBatteryAbout,
    tips: standardBatteryTips,
    legalInfo: {
      type: "green",
      title: "Schváleno pro provoz na pozemních komunikacích",
      text: "Tato baterie s pracovním napětím do 48V podléhá evropské normě EN 15194 a je plně schválena pro provoz na pozemních komunikacích v kombinaci s odpovídajícím motorem. Za jakékoliv vlastní úpravy nese plnou zodpovědnost kupující.",
    },
    packageContents: getBatteryPackage(
      "36V 15.6Ah",
      "Články 18650 2600mAh, kapacita 561.6Wh, rozložení 10s6p, BMS 30A (peak 90A)."
    ),
  },
  bat_36v24: {
    id: "bat_36v24",
    name: "36V 24Ah",
    price: 6999,
    type: "battery",
    images: ["/images/bat36V24Ah.png"],
    specsTable: [
      { label: "Napětí", value: "36V" },
      { label: "Kapacita", value: "24Ah" },
      { label: "Energie", value: "864Wh" },
      { label: "Články", value: "L-G 21700 4800mAh" },
      { label: "Rozložení", value: "10s5p" },
      { label: "BMS", value: "30A" },
      { label: "Špičkový výkon", value: "90A" },
      { label: "Hmotnost", value: "4,5 kg" },
      { label: "Dojezd (eco)", value: "až 135 km" },
    ],
    about: standardBatteryAbout,
    tips: standardBatteryTips,
    legalInfo: {
      type: "green",
      title: "Schváleno pro provoz na pozemních komunikacích",
      text: "Tato baterie s pracovním napětím do 48V podléhá evropské normě EN 15194 a je plně schválena pro provoz na pozemních komunikacích v kombinaci s odpovídajícím motorem. Za jakékoliv vlastní úpravy nese plnou zodpovědnost kupující.",
    },
    packageContents: getBatteryPackage(
      "36V 24Ah",
      "Výkonná lithiová baterie s kapacitou 864Wh, prémiové články L-G 21700 4800mAh v rozložení 10s5p. Vybavena kvalitním BMS systémem 30A (peak 90A) pro extrémní dojezd."
    ),
  },
  bat_48v13: {
    id: "bat_48v13",
    name: "48V 13Ah",
    price: 5849,
    type: "battery",
    images: ["/images/bat48V13+16Ah.png"],
    specsTable: [
      { label: "Napětí", value: "48V" },
      { label: "Kapacita", value: "13Ah" },
      { label: "Energie", value: "624Wh" },
      { label: "Články", value: "18650 2600mAh" },
      { label: "Rozložení", value: "13s5p" },
      { label: "BMS", value: "30A" },
      { label: "Špičkový výkon", value: "90A" },
      { label: "Hmotnost", value: "4,0 kg" },
      { label: "Dojezd (eco)", value: "až 100 km" },
    ],
    about: standardBatteryAbout,
    tips: standardBatteryTips,
    legalInfo: {
      type: "green",
      title: "Schváleno pro provoz na pozemních komunikacích",
      text: "Tato baterie s pracovním napětím do 48V podléhá evropské normě EN 15194 a je plně schválena pro provoz na pozemních komunikacích v kombinaci s odpovídajícím motorem. Za jakékoliv vlastní úpravy nese plnou zodpovědnost kupující.",
    },
    packageContents: getBatteryPackage(
      "48V 13Ah",
      "Výkonná lithiová baterie s kapacitou 624Wh, články 18650 2600mAh v rozložení 13s5p. Vybavena kvalitním BMS systémem 30A (peak 90A) pro maximální bezpečnost a stabilní výkon."
    ),
  },
  bat_48v16: {
    id: "bat_48v16",
    name: "48V 16Ah",
    price: 6449,
    type: "battery",
    images: ["/images/bat48V13+16Ah.png"],
    specsTable: [
      { label: "Napětí", value: "48V" },
      { label: "Kapacita", value: "16Ah" },
      { label: "Energie", value: "768Wh" },
      { label: "Články", value: "18650 3200mAh" },
      { label: "Rozložení", value: "13s5p" },
      { label: "BMS", value: "30A" },
      { label: "Špičkový výkon", value: "90A" },
      { label: "Hmotnost", value: "4,8 kg" },
      { label: "Dojezd (eco)", value: "až 120 km" },
    ],
    about: standardBatteryAbout,
    tips: standardBatteryTips,
    legalInfo: {
      type: "green",
      title: "Schváleno pro provoz na pozemních komunikacích",
      text: "Tato baterie s pracovním napětím do 48V podléhá evropské normě EN 15194 a je plně schválena pro provoz na pozemních komunikacích v kombinaci s odpovídajícím motorem. Za jakékoliv vlastní úpravy nese plnou zodpovědnost kupující.",
    },
    packageContents: getBatteryPackage(
      "48V 16Ah",
      "Výkonná lithiová baterie s kapacitou 768Wh, kvalitní články 18650 3200mAh v rozložení 13s5p. Spolehlivý BMS systém 30A (peak 90A)."
    ),
  },
  bat_48v20: {
    id: "bat_48v20",
    name: "48V 20Ah",
    price: 8649,
    type: "battery",
    images: ["/images/bat48V20Ah.png"],
    specsTable: [
      { label: "Napětí", value: "48V" },
      { label: "Kapacita", value: "20Ah" },
      { label: "Energie", value: "960Wh" },
      { label: "Články", value: "Samsung 21700 5000mAh" },
      { label: "Rozložení", value: "13s4p" },
      { label: "BMS", value: "30A" },
      { label: "Špičkový výkon", value: "90A" },
      { label: "Hmotnost", value: "5,2 kg" },
      { label: "Dojezd (eco)", value: "až 150 km" },
    ],
    about: standardBatteryAbout,
    tips: standardBatteryTips,
    legalInfo: {
      type: "green",
      title: "Schváleno pro provoz na pozemních komunikacích",
      text: "Tato baterie s pracovním napětím do 48V podléhá evropské normě EN 15194 a je plně schválena pro provoz na pozemních komunikacích v kombinaci s odpovídajícím motorem. Za jakékoliv vlastní úpravy nese plnou zodpovědnost kupující.",
    },
    packageContents: getBatteryPackage(
      "48V 20Ah",
      "Vysokokapacitní baterie 960Wh pro 48V systems s masivním dojezdem. Vybavena kvalitním BMS 30A (peak 90A)."
    ),
  },
  bat_52v20: {
    id: "bat_52v20",
    name: "52V 20Ah",
    price: 8749,
    type: "battery",
    images: ["/images/bat52V20Ah.png"],
    specsTable: [
      { label: "Napětí", value: "52V" },
      { label: "Kapacita", value: "20Ah" },
      { label: "Energie", value: "1040Wh" },
      { label: "Články", value: "Samsung 21700 5000mAh" },
      { label: "Rozložení", value: "14s4p" },
      { label: "BMS", value: "30A" },
      { label: "Špičkový výkon", value: "90A" },
      { label: "Hmotnost", value: "5,6 kg" },
      { label: "Dojezd (eco)", value: "až 200 km" },
      { label: "Životnost", value: "až 5000 cyklů" },
    ],
    about: standardBatteryAbout,
    tips: standardBatteryTips,
    legalInfo: {
      type: "red",
      title: "Upozornění k provozu na komunikacích (Pouze Off-road)",
      text: "Tato baterie s napětím 52V NESPLŇUJE evropskou normu EN 15194 pro provoz na pozemních komunikacích z důvodu nadlimitního napětí. Je určena výhradně pro použití mimo veřejné komunikace (off-road) nebo na soukromých cestách. Za případný provoz na silnicích a jakékoliv úpravy nese plnou zodpovědnost výhradně kupující.",
    },
    packageContents: getBatteryPackage(
      "52V 20Ah",
      "Nejvýkonnější baterie v naší nabídce s kapacitou 1040Wh, články Samsung 21700 5000mAh. Ideální pro extrémní zátěž a dlouhé cesty."
    ),
  },
  disp_dz40: {
    id: "disp_dz40",
    name: "DZ40",
    price: 599,
    type: "display",
    images: ["/images/dz40_1.avif", "/images/dz40_2.png"],
    about: "<p>Kompaktní a nenápadný IPS displej DZ40 je ideální pro jezdce, kteří preferují čistá řídítka a minimalistický design. I přes své malé rozměry poskytuje všechny důležité informace o vaší jízdě.</p> <br> <strong>Hlavní výhody:</strong> <ul className='list-disc pl-5 mt-2 space-y-1'><li>Jasný 1.68\" IPS displej s výbornou čitelností na slunci</li><li>Zobrazení všech základních údajů (rychlost, stav baterie, stupeň asistence)</li><li>Minimalistické rozměry, které nepřekáží na řídítkách</li></ul>",
    specsTable: [
      { label: "Displej", value: '1.68" IPS' },
      { label: "Úrovně asistence", value: "5" },
      { label: "Průměr řídítek", value: "22.2 mm" },
      { label: "Provozní napětí", value: "24V / 36V / 48V / 52V" },
      { label: "Jazyk", value: "Angličtina" },
      { label: "USB port", value: "Ne" },
      { label: "Omezení rychlosti", value: "Ano" },
      { label: "Zobrazení napětí baterie", value: "Ano" },
      { label: "Zobrazení procent baterie", value: "Ano" },
      { label: "Heslo pro spuštění", value: "Ne" },
      { label: "Světelný senzor", value: "Ne" }
    ],
  },
  disp_sw2: {
    id: "disp_sw2",
    name: "SW2-M58",
    price: 799,
    type: "display",
    images: ["/images/sw2-m58_1.png", "/images/sw2-m58_2.png"],
    about: "<p>Velký a velmi přehledný 3.8\" LCD displej SW2-M58 se umisťuje do středu řídítek a poskytne vám dokonalý přehled o všech parametrech vaší cesty pouhým mrknutím oka.</p> <br> <strong>Co na něm oceníte:</strong> <ul class='list-disc pl-5 mt-2 space-y-1'><li>Velké číslice pro perfektní čitelnost i ve vysoké rychlosti</li><li>Elegantní umístění přímo uprostřed řídítek pro maximální přehled</li><li>Široká kompatibilita s různými průměry řídítek díky přibaleným redukcím</li></ul>",
    specsTable: [
      { label: "Displej", value: '3.8" LCD' },
      { label: "Úrovně asistence", value: "5" },
      { label: "Průměr řídítek", value: "22.2 / 25.4 / 31.8 mm" },
      { label: "Provozní napětí", value: "24V / 36V / 48V / 52V" },
      { label: "Jazyk", value: "Angličtina" },
      { label: "USB port", value: "Ne" },
      { label: "Omezení rychlosti", value: "Ano" },
      { label: "Zobrazení napětí baterie", value: "Ano" },
      { label: "Zobrazení procent baterie", value: "Ano" },
      { label: "Světelný senzor", value: "Ne" }
    ],
  },
  disp_ekd01: {
    id: "disp_ekd01",
    name: "EKD01",
    price: 1099,
    type: "display",
    images: [
      "/images/ekd01_1.jpeg",
      "/images/ekd01_2.jpeg",
      "/images/ekd01_3.webp",
      "/images/ekd01_4.png",
    ],
    about: "<p>Prémiový barevný TFT displej EKD01 představuje to nejlepší, co si můžete na své elektrokolo pořídit. Jako jeden z mála nabízí uživatelské menu kompletně <strong>v češtině</strong> a disponuje portem pro nabíjení telefonu za jízdy.</p> <br> <strong>Proč zvolit právě EKD01:</strong> <ul class='list-disc pl-5 mt-2 mb-6 space-y-1'><li>Nádherný 2.4\" barevný displej s vysokým kontrastem</li><li><strong>Menu kompletně v českém jazyce</strong></li><li>Integrovaný moderní USB-C port pro nabíjení telefonu nebo navigace</li><li>Pokročilé nastavení a zabezpečení PIN kódem</li></ul> <p><strong>Chytrá aplikace BikeGO:</strong><br>Displej navíc plně podporuje propojení s vaším chytrým telefonem přes Bluetooth. Přes aplikaci BikeGO si můžete kolo snadno nastavit, sledovat detailní statistiky nebo využít telefon jako velký palubní počítač. Aplikaci stáhnete zde:</p> <div class='flex flex-col sm:flex-row gap-3 mt-4'><a href='https://play.google.com/store/apps/details?id=com.huiye.ebike&hl=cs' target='_blank' rel='noreferrer' class='inline-flex items-center justify-center px-5 py-2.5 bg-blue-50 border border-blue-200 text-blue-700 font-bold rounded-lg hover:bg-blue-100 transition-colors shadow-sm no-underline'>📱 Stáhnout pro Android</a><a href='https://apps.apple.com/de/app/bikego/id1615694432' target='_blank' rel='noreferrer' class='inline-flex items-center justify-center px-5 py-2.5 bg-blue-50 border border-blue-200 text-blue-700 font-bold rounded-lg hover:bg-blue-100 transition-colors shadow-sm no-underline'>🍏 Stáhnout pro Apple</a></div>",
    specsTable: [
      { label: "Displej", value: '2.4" TFT' },
      { label: "Úrovně asistence", value: "5" },
      { label: "Průměr řídítek", value: "22.2 / 25.4 mm" },
      { label: "Provozní napětí", value: "24V / 36V / 48V / 52V" },
      { label: "Pokročilé nastavení (kód)", value: "2020" },
      { label: "Jazyk", value: "Angličtina, Francouzština, Němčina, Španělština, Italština, Polština, Nizozemština, Čeština" },
      { label: "USB port", value: "Ano (Type C)" },
      { label: "Omezení rychlosti", value: "Ano" },
      { label: "Zobrazení napětí baterie", value: "Ano" },
      { label: "Zobrazení procent baterie", value: "Ano" },
      { label: "Heslo pro spuštění", value: "Ano" },
      { label: "Světelný senzor", value: "Ne" }
    ],
  },
  brk_sens: {
    id: "brk_sens",
    name: "Brzdové senzory",
    price: 0,
    type: "brake",
    images: ["/images/brzdovysenzor.png"], 
    specsTable: [{ label: "Kompatibilita", value: "Hydraulické brzdy" }],
  },
  brk_lev: {
    id: "brk_lev",
    name: "Brzdové páčky",
    price: 0,
    type: "brake",
    images: ["/images/brzdovepacky.png"],
    specsTable: [{ label: "Kompatibilita", value: "Mechanické brzdy" }],
  },
};

export const configuratorData = {
  motors: [
    { id: "mot_250", name: "TSDZ2B 250W", price: 9799 },
    { id: "mot_750", name: "TSDZ8 750W", price: 10999 },
    { id: "mot_1000", name: "TSDZ16 1000W", price: 13199 },
  ],
  batteries: [
    { id: "bat_none", name: "Žádná baterie", price: 0, priceText: "Zdarma" },
    { id: "bat_36v13", name: "36V 13Ah", price: 4749 },
    { id: "bat_36v15_6", name: "36V 15.6Ah", price: 5149 },
    { id: "bat_36v24", name: "36V 24Ah", price: 6999 },
    { id: "bat_48v13", name: "48V 13Ah", price: 5849 },
    { id: "bat_48v16", name: "48V 16Ah", price: 6449 },
    { id: "bat_48v20", name: "48V 20Ah", price: 8649 },
    { id: "bat_52v20", name: "52V 20Ah", price: 8749 },
  ],
  displays: [
    { id: "disp_dz40", name: "DZ40", price: 599 },
    { id: "disp_sw2", name: "SW2-M58", price: 799 },
    { id: "disp_ekd01", name: "EKD01", price: 1099 },
  ],
  brakes: [
    {
      id: "brk_sens",
      name: "Brzdové senzory",
      price: 0,
      desc: "Senzory - pouze pro hydraulické brzdy",
      priceText: "Zdarma",
      images: ["/images/brzdovysenzor.png"],
    },
    {
      id: "brk_lev",
      name: "Brzdové páčky",
      price: 0,
      desc: "Páčky - pouze pro mechanické brzdy",
      priceText: "Zdarma",
    },
  ],
  assembly: [
    {
      id: "asm_self",
      name: "Bez montáže",
      price: 0,
      desc: "Komponenty budou zaslány na vaši adresu. Při vlastní montáži přebírá odpovědnost za škody vzniklé montáží kupující.",
      link: "Více v obchodních podmínkách",
      priceText: "Zdarma",
    },
    {
      id: "asm_shop",
      name: "Montáž v dílně",
      price: 999,
      desc: "Přivezete kolo k nám, montáž 999 Kč",
    },
    {
      id: "asm_home",
      name: "Montáž u vás doma",
      price: 999,
      desc: "Přijedeme k vám domů a provedeme montáž na místě",
      priceText: "999 Kč + doprava",
    },
  ],
};